var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-nocheck
import { useParams, useHistory } from 'react-router-dom';
import { DateTime } from 'luxon';
import React, { useCallback, useState, useRef, } from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import kfetch from '@kareo/kfetch';
import { Input, Label, P, H3 } from 'shared-assets/components/Elements/';
import TalkingParrotLib, { DOB_INPUT_FORMAT, } from 'shared-assets/components/TalkingParrot/lib';
import analytics from 'shared-assets/lib/analytics';
import Button from 'shared-assets/components/Elements/Button';
import colors from 'shared-assets/lib/colors';
import Icon from 'shared-assets/components/Icon';
import Spinner from 'shared-assets/components/Spinner';
import TelehealthLogo from 'shared-assets/talking-parrot-ui/components/TelehealthLogo';
import LayoutCentered from './LayoutCentered';
import VideoService from './VideoService';
var DOB_VALIDATION_IN_YEARS = 150;
var VERIFICATION_ERRORS = {
    INVALID_DOB: 'INVALID_DOB',
    INVALID_ID: 'INVALID_ID',
    INVALID_DATE_TIME: 'INVALID_DATE_TIME',
    UNKNOWN: 'UNKNOWN',
};
var PublicUi = function () {
    var _a = useParams(), uniqueIdForUrl = _a.uniqueIdForUrl, type = _a.type, customerId = _a.customerId;
    var _b = useState(null), room = _b[0], setRoom = _b[1];
    var _c = useState(''), dob = _c[0], setDOB = _c[1];
    var _d = useState(false), validDob = _d[0], setValidDob = _d[1];
    var inputRef = useRef(null);
    var buttonRef = useRef(null);
    var _e = useState(false), verifying = _e[0], setVerifying = _e[1];
    var _f = useState(null), verificationError = _f[0], setVerificationError = _f[1];
    var history = useHistory();
    var onVerifyClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var largeRoom, publicUrl, res, redirectUrl, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setVerifying(true);
                    largeRoom = !!type;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, TalkingParrotLib.publicAppointmentUrl({ uniqueIdForUrl: uniqueIdForUrl, customerId: customerId }, dob, largeRoom)];
                case 2:
                    publicUrl = _b.sent();
                    return [4 /*yield*/, kfetch(publicUrl.toString())];
                case 3:
                    res = _b.sent();
                    if (!!res) {
                        redirectUrl = res.staticUrl || ((_a = res.room) === null || _a === void 0 ? void 0 : _a.url);
                        if (!!redirectUrl) {
                            window.location.replace(redirectUrl);
                        }
                        setVerificationError(null);
                        setRoom(__assign({}, res.room));
                    }
                    else {
                        setVerificationError(VERIFICATION_ERRORS.INVALID_DATE_TIME);
                        throw new Error('response from talking parrot create or join API is invalid, room not set');
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _b.sent();
                    setVerificationError(VERIFICATION_ERRORS.UNKNOWN);
                    return [3 /*break*/, 6];
                case 5:
                    setVerifying(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var validateDob = function (e) {
        var inputElement = e.currentTarget;
        var val = inputElement.value;
        var validFormat = DOB_INPUT_FORMAT;
        var addingCharacter = val.length > dob.length;
        if (val.length < validFormat.length) {
            setValidDob(false);
            if (inputRef.current !== null) {
                inputRef.current.setCustomValidity('Invalid date of birth');
            }
            switch (val.length) {
                case 2:
                    if (addingCharacter) {
                        // adding new vs remove characters
                        setDOB(val + '/');
                    }
                    else {
                        setDOB(val.slice(0, -1));
                    }
                    break;
                case 5:
                    if (val.length > dob.length) {
                        // adding new vs remove characters
                        setDOB(val + '/');
                    }
                    else {
                        setDOB(val.slice(0, -1));
                    }
                    break;
                default:
                    setDOB(val);
                    break;
            }
        }
        else {
            var date = DateTime.fromFormat(val, validFormat, { zone: 'local' });
            var today = DateTime.local();
            var diff = today.diff(date, ['days', 'years']);
            if (Number(diff.years) < DOB_VALIDATION_IN_YEARS &&
                Number(diff.days) > 0) {
                setValidDob(true);
                setVerificationError(null);
                if (inputRef.current !== null) {
                    inputRef.current.setCustomValidity('');
                }
            }
            else {
                setValidDob(false);
                if (inputRef.current !== null) {
                    inputRef.current.setCustomValidity('Invalid date of birth');
                }
            }
            setDOB(val);
        }
    };
    var videoStatusCallback = useCallback(function (statusType) {
        switch (statusType) {
            case 'leave':
                history.push("/endSession/" + uniqueIdForUrl);
                break;
            case 'ready':
                analytics.track('Room Joined', {
                    name: 'Telehealth',
                    type: 'pubilc v2',
                    uniqueIdForUrl: uniqueIdForUrl,
                });
                break;
            default:
                break;
        }
    }, []);
    return !room ? (React.createElement(LayoutCentered, null,
        React.createElement(TelehealthLogo, null),
        React.createElement(Card, { style: { width: '100%' } },
            React.createElement(CardContent, null,
                React.createElement(Grid, { item: true },
                    React.createElement(H3, null, "Verification Step"),
                    React.createElement(P, { style: { padding: 0 } }, "Please enter your date of birth (or the patient's DOB for this appointment)."),
                    React.createElement(Grid, { item: true, xs: 12, md: 5 },
                        React.createElement(Label, null, "Date of Birth"),
                        React.createElement(Input, { inputRef: inputRef, autoFocus: true, type: "text", name: "dob", placeholder: "MM/DD/YYYY", onChange: validateDob, value: dob, required: true })),
                    React.createElement(Box, { mt: 1 },
                        React.createElement(Button, { ref: buttonRef, disabled: !validDob || !!verifying, onClick: onVerifyClick, type: "button", className: "primary" }, !!verifying ? (React.createElement(Grid, { container: true, alignItems: "center" },
                            React.createElement(Spinner, null),
                            "Verifying...")) : ('Verify'))),
                    !!verificationError ? (React.createElement(Grid, { container: true, component: Box, mt: 1 },
                        React.createElement(Grid, { item: true },
                            React.createElement(Icon, { type: "attention-alt", fillColor: colors.error })),
                        React.createElement(Grid, { item: true, xs: 11, style: { color: colors.error } },
                            React.createElement(P, { color: colors.error, style: { marginTop: 0, paddingRight: 0 } }, "The appointment couldn't be started because of one of the following reasons:"),
                            React.createElement("ul", null,
                                React.createElement("li", null, "Date of birth may be invalid"),
                                React.createElement("li", null, "You're too early/late to the appointment")),
                            React.createElement(P, { color: colors.error, style: { marginTop: 0, paddingRight: 0 } }, "Please try again, or contact the practice (the phone number can be found in the appointment reminder).")))) : null))))) : (React.createElement(VideoService, { room: room, title: "Telehealth " + uniqueIdForUrl, videoStatusCallback: videoStatusCallback }));
};
export default PublicUi;
